import { render, staticRenderFns } from "./bottom-navigation.vue?vue&type=template&id=ccf9a99e&scoped=true"
import script from "./bottom-navigation.vue?vue&type=script&lang=js"
export * from "./bottom-navigation.vue?vue&type=script&lang=js"
import style0 from "./bottom-navigation.vue?vue&type=style&index=0&id=ccf9a99e&prod&lang=scss&scoped=true"
import style1 from "./bottom-navigation.vue?vue&type=style&index=1&id=ccf9a99e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf9a99e",
  null
  
)

export default component.exports